import { render } from "./ContactUsSecondary.vue?vue&type=template&id=65a0f28f&scoped=true&ts=true"
import script from "./ContactUsSecondary.vue?vue&type=script&lang=ts"
export * from "./ContactUsSecondary.vue?vue&type=script&lang=ts"

import "./ContactUsSecondary.vue?vue&type=style&index=0&id=65a0f28f&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a0f28f"]])

export default __exports__